import ApiError from 'src/api/errorHandling/ApiError';
import { fetchGuidancePdfFull } from 'src/api/pdfAPI';

export default async function ShowGuidancePdf(formId: number) {
  const data = await fetchGuidancePdfFull({ formId: +formId })
    .catch(e => {
      const apiError = e as ApiError;
      if (apiError.statusCode === 404) return null;
      throw apiError;
    });

  if (data) {
    window.open(window.URL.createObjectURL(data as Blob));
  }
}
